// utils/investmentMetrics.js

const DAY_MS = 1000 * 60 * 60 * 24;

export const npv = (rate, cashflows) => {
  const r = Number(rate || 0) / 100;
  return cashflows.reduce((sum, cf, idx) => {
    const denom = Math.pow(1 + r, idx);
    return sum + (Number(cf.amount || 0) / denom);
  }, 0);
};

export const xnpv = (rate, cashflows) => {
  if (!cashflows.length) return 0;
  const r = Number(rate || 0);
  const t0 = new Date(cashflows[0].date).getTime();
  return cashflows.reduce((sum, cf) => {
    const t = new Date(cf.date).getTime();
    const years = (t - t0) / DAY_MS / 365;
    return sum + Number(cf.amount || 0) / Math.pow(1 + r, years);
  }, 0);
};

const dxnpv = (rate, cashflows) => {
  if (!cashflows.length) return 0;
  const t0 = new Date(cashflows[0].date).getTime();
  return cashflows.reduce((sum, cf) => {
    const t = new Date(cf.date).getTime();
    const years = (t - t0) / DAY_MS / 365;
    return sum - (years * Number(cf.amount || 0)) / Math.pow(1 + rate, years + 1);
  }, 0);
};

export const xirr = (cashflows, guess = 0.1) => {
  if (!cashflows || cashflows.length < 2) return null;
  let rate = guess;
  for (let i = 0; i < 100; i++) {
    const f = xnpv(rate, cashflows);
    const df = dxnpv(rate, cashflows);
    if (Math.abs(df) < 1e-10) break;
    const newRate = rate - f / df;
    if (Math.abs(newRate - rate) <= 1e-7) return newRate;
    rate = newRate;
  }
  return null;
};

export const irr = (cashflows) => {
  if (!cashflows || cashflows.length < 2) return null;
  const amounts = cashflows.map((cf) => Number(cf.amount || 0));
  let rate = 0.1;
  for (let i = 0; i < 100; i++) {
    let npvVal = 0;
    let dNpv = 0;
    for (let t = 0; t < amounts.length; t++) {
      npvVal += amounts[t] / Math.pow(1 + rate, t);
      dNpv -= t * amounts[t] / Math.pow(1 + rate, t + 1);
    }
    if (Math.abs(dNpv) < 1e-10) break;
    const newRate = rate - npvVal / dNpv;
    if (Math.abs(newRate - rate) <= 1e-7) return newRate;
    rate = newRate;
  }
  return null;
};

export const toPercent = (rate) => (rate === null ? null : rate * 100);
